import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import ErEditAccordion from "./ErEditAccordion";
import { ELEMENT_ENTRY_ANIMATIONS, ENTRY_ANIMATION_SPEEDS } from "./escapeRoomEditorConstants";

export default function ElementEntryAnimationPanel({ selectedElement, effectiveUpdateElement }) {
	const el = selectedElement;
	const entryAnimation = el?.entryAnimation || "none";
	const entryAnimationDuration = Number(el?.entryAnimationDuration);
	const durationMs = Number.isFinite(entryAnimationDuration) && entryAnimationDuration > 0
		? entryAnimationDuration
		: 500;

	return (
		<ErEditAccordion title="Animación" icon={FlashOnIcon} defaultOpen>
			<ErEditAccordion title="Entrada en la página" nested defaultOpen>
				<Box fontSize={11} color="#64748b" mb={1.25} lineHeight={1.45}>
					Se ejecuta al entrar en la página donde está este elemento.
				</Box>
				<FormControl variant="outlined" size="small" fullWidth style={{ marginBottom: 12 }}>
					<InputLabel>Tipo de entrada</InputLabel>
					<Select
						value={entryAnimation}
						onChange={(e) => effectiveUpdateElement({ elementId: el.elementId, entryAnimation: e.target.value })}
						label="Tipo de entrada"
						style={{ fontSize: 14 }}
					>
						{ELEMENT_ENTRY_ANIMATIONS.map((t) => (
							<MenuItem key={t.id} value={t.id}>{t.label}</MenuItem>
						))}
					</Select>
				</FormControl>
				{entryAnimation !== "none" ? (
					<FormControl variant="outlined" size="small" fullWidth>
						<InputLabel>Velocidad</InputLabel>
						<Select
							value={ENTRY_ANIMATION_SPEEDS.some((s) => s.ms === durationMs) ? durationMs : 500}
							onChange={(e) => effectiveUpdateElement({ elementId: el.elementId, entryAnimationDuration: Number(e.target.value) })}
							label="Velocidad"
							style={{ fontSize: 14 }}
						>
							{ENTRY_ANIMATION_SPEEDS.map((s) => (
								<MenuItem key={s.ms} value={s.ms}>{s.label}</MenuItem>
							))}
						</Select>
					</FormControl>
				) : null}
			</ErEditAccordion>
		</ErEditAccordion>
	);
}
